module.exports = __webpack_public_path__ + "img/example-4.29765049.png";